import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import Terms from './Terms';
import Privacy from './Privacy';
import Support from './Support';
import ToStore from './ToStore';
import { useScrollToTop } from '../utils/useScrollToTop';
import '../styles/screens/App.css';

const AppRoutes: React.FC = () => {
  useScrollToTop();
  
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/support" element={<Support />} />
      <Route path="/to-store" element={<ToStore />} />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <div className="app-container">
        <AppRoutes />
      </div>
    </Router>
  );
};

export default App;
